import { DEFAULT_LOCALE } from '~/i18n/locales';
import type { RouteLocationNormalizedGeneric } from 'vue-router';

export function useLanguage(routeArg?: RouteLocationNormalizedGeneric): {
    lang: ComputedRef<string>;
    country: ComputedRef<string>;
    urlSegment: ComputedRef<string>;
    i18nLocale: ComputedRef<string>;
} {
    const { languageCookie, countryCookie } = useCountryLanguageCookies();
    const countryLanguages = useCountryLanguages();
    const route = routeArg ?? useRoute();

    const matchedPathLocale = computed(() => parseLocaleFromPath(route.path));

    const country = computed(() => {
        return matchedPathLocale.value?.country || countryCookie.value || Object.keys(countryLanguages)[0] || 'de';
    });

    const lang = computed(() => {
        return (
            matchedPathLocale.value?.language ||
            languageCookie.value ||
            countryLanguages[country.value]?.defaultLanguage ||
            /**
             * We can't use `useI18n().defaultLocale` here, because `useLanguage()` is getting used in places where
             * the i18n context may be missing.
             */
            DEFAULT_LOCALE
        );
    });

    const urlSegment = computed(() => {
        return `${country.value}-${lang.value}`;
    });

    const i18nLocale = computed(() => getI18nLocale(country.value, lang.value));

    return { lang, country, urlSegment, i18nLocale };
}
